/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PrivateBankingProductCatalogueListResult,
  ProductCatalogueListResult,
} from '../models/index';
import {
    PrivateBankingProductCatalogueListResultFromJSON,
    PrivateBankingProductCatalogueListResultToJSON,
    ProductCatalogueListResultFromJSON,
    ProductCatalogueListResultToJSON,
} from '../models/index';

export interface GetEligiblePrivateBankingProductsForBrRequest {
    brUid: string;
}

export interface GetEligibleProductsForBrRequest {
    brUid: string;
}

/**
 * 
 */
export class ProductCatalogueApi extends runtime.BaseAPI {

    /**
     * Creates request options for getAllProducts without sending the request
     */
    async getAllProductsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/productcatalogue/products`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all products from database
     * Get all products
     */
    async getAllProductsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductCatalogueListResult>> {
        const requestOptions = await this.getAllProductsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductCatalogueListResultFromJSON(jsonValue));
    }

    /**
     * Retrieve all products from database
     * Get all products
     */
    async getAllProducts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductCatalogueListResult> {
        const response = await this.getAllProductsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getEligiblePrivateBankingProductsForBr without sending the request
     */
    async getEligiblePrivateBankingProductsForBrRequestOpts(requestParameters: GetEligiblePrivateBankingProductsForBrRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling getEligiblePrivateBankingProductsForBr().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/productcatalogue/privateBanking/eligibleProducts/br/{brUid}`;
        urlPath = urlPath.replace(`{${"brUid"}}`, encodeURIComponent(String(requestParameters['brUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all eligible products based on Actico rules
     * Get all private banking eligible products that is possible to add for a given BR
     */
    async getEligiblePrivateBankingProductsForBrRaw(requestParameters: GetEligiblePrivateBankingProductsForBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrivateBankingProductCatalogueListResult>> {
        const requestOptions = await this.getEligiblePrivateBankingProductsForBrRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrivateBankingProductCatalogueListResultFromJSON(jsonValue));
    }

    /**
     * Retrieve all eligible products based on Actico rules
     * Get all private banking eligible products that is possible to add for a given BR
     */
    async getEligiblePrivateBankingProductsForBr(requestParameters: GetEligiblePrivateBankingProductsForBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrivateBankingProductCatalogueListResult> {
        const response = await this.getEligiblePrivateBankingProductsForBrRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getEligibleProductsForBr without sending the request
     */
    async getEligibleProductsForBrRequestOpts(requestParameters: GetEligibleProductsForBrRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling getEligibleProductsForBr().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/productcatalogue/eligibleProducts/br/{brUid}`;
        urlPath = urlPath.replace(`{${"brUid"}}`, encodeURIComponent(String(requestParameters['brUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all eligible products based on Drools result
     * Get all eligible products for business relationship
     */
    async getEligibleProductsForBrRaw(requestParameters: GetEligibleProductsForBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductCatalogueListResult>> {
        const requestOptions = await this.getEligibleProductsForBrRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductCatalogueListResultFromJSON(jsonValue));
    }

    /**
     * Retrieve all eligible products based on Drools result
     * Get all eligible products for business relationship
     */
    async getEligibleProductsForBr(requestParameters: GetEligibleProductsForBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductCatalogueListResult> {
        const response = await this.getEligibleProductsForBrRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
